export const auditGridDirectionsEnum = {
    default: 0,
    next: 1,
    previous: 2,
};